import React, { useContext, useEffect, useRef, useState } from "react";
import { AttachIntegration, NumberField, TextArea, TimerField } from "./Tools";
import { actions, WorkflowContext } from "../../store/workflow.store";
import { NavLink } from "react-router-dom";
import MappingModal from "../../../Settings/Integration/Modals/MappingModal/MappingModal";
import {
  createWorkflow,
  getTemplates,
  getWorkflows,
  updateBlock,
} from "../../../../services/api/workflows.api";
import { DASHBOARD_URL } from "../../../../constants";
import {
  InfoToolTip,
  ModalMessage,
  Permissions,
  Tooltip,
} from "../../../../components";
import allIntegrations from "../allIntegrations";
import { getAccounts } from "../../../../services/api/integrations.api";
import { checkPermission, dfs } from "../../../../services/utils";
import { ToastContainer, toast } from "react-toastify";
import { Form, OverlayTrigger } from "react-bootstrap";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import { reversDfs } from "../../../../services/utils/dfs";
import ConnectionModal from "../../../Settings/Integration/Modals/ConnectionModal/ConnectionModal";
import { usePermissions } from "../../../../components/Permissions/permissions.hooks";

export default function TemplateSettings({
  active,
  handleSettingsToggle,
  blockOptions,
  profile,
  organizationCredits,
}) {
  const [checkPlanPermissions, checkMemberPermissions] = usePermissions(
    organizationCredits &&
      organizationCredits.plan &&
      organizationCredits.plan.permissions,
    profile.permissions,
    "Workflow"
  );
  const handleStepSave = async (block) => {
    if (blockOptions._id) {
      if (
        checkPermission({
          permissions: profile.permissions,
          name: "Workflow",
          action: "Edit",
        })
      ) {
        await updateBlock(block);
      } else {
        toast.error(
          "You dont have access to this feature! Please contact your admin\n" +
            "                to give you access"
        );
      }
    }
    handleSettingsToggle(true);
  };

  const SETTINGS_TYPE = {
    "linkedin-invite": (
      <InvitationConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        handleStepSave={handleStepSave}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "linkedin-message": (
      <MessageConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        handleStepSave={handleStepSave}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "linkedin-is-contact-bulk": (
      <TimerConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        handleStepSave={handleStepSave}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "linkedin-has-responded-bulk": (
      <TimerConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        handleStepSave={handleStepSave}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "wokflow-attach": (
      <AttachBlock
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        profile={profile}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "linkedin-enrich": (
      <EnrichConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        handleStepSave={handleStepSave}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    integration: (
      <IntegrationConfig
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
    "attached-block": (
      <AttachedBock
        blockOptions={blockOptions}
        handleSettingsToggle={handleSettingsToggle}
        profile={profile}
        checkPlanPermissions={checkPlanPermissions}
        checkMemberPermissions={checkMemberPermissions}
      />
    ),
  };
  return (
    <div className={"workflow-setting " + (blockOptions ? "active" : "")}>
      <div className="setting-inner-wrap">
        {/*CONFIG BLOCKs*/}
        {blockOptions.attached
          ? SETTINGS_TYPE[blockOptions.attached]
          : blockOptions && blockOptions.action.match("integration")
          ? SETTINGS_TYPE["integration"]
          : SETTINGS_TYPE[blockOptions.action]}
      </div>
    </div>
  );
}

function InvitationConfig({
  handleSettingsToggle,
  handleStepSave,
  blockOptions,
  checkMemberPermissions,
  checkPlanPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);
  const [isVarValid, setIsVarValid] = useState(true);
  const textAreaRef = useRef();
  const handleOnChange = (value, type) => {
    let template = state.selectedTemplate;
    const dfsResults = dfs(blockOptions.id, state.selectedTemplate.blocks);
    template.blocks = state.selectedTemplate.blocks.map((block) => {
      if (type == "isActive") {
        if (dfsResults.some((id) => id === block.id)) {
          block.active = value;
          return block;
        }
      }
      if (block.id == blockOptions.id) {
        let options = block.options;
        options[type] = value;
        block.options = options;
      }
      return block;
    });
    dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
  };

  const getBlockActivation = () => {
    let block = state.selectedTemplate.blocks.find(
      (block) => block.id == blockOptions.id
    );

    return block;
  };

  return (
    <div className={"step1 " + (blockOptions ? "active" : "")}>
      <div className="setting-heading">
        <a
          href="#"
          className="close-btn"
          onClick={() => handleSettingsToggle()}
        >
          &times;
        </a>
        <label>
          <FormattedMessage id={"workflow.settings.step"} /> 1
        </label>
        <h4>
          <FormattedMessage id={"workflow.linkedinInvitation"} />
        </h4>
        <p>
          <FormattedMessage
            id={"workflow.settings.thisActionsSendsInvitation"}
          />
        </p>
      </div>
      <p className="sub-heading">
        {" "}
        <FormattedMessage id={"workflow.settings.dailyInvitationLimit"} />
      </p>
      <p className="desc">
        {" "}
        <FormattedMessage id={"workflow.settings.setTheNoOfInvitation"} />
      </p>
      <NumberField
        onChange={(batchLimit) => handleOnChange(batchLimit, "batchLimit")}
        value={blockOptions.options.batchLimit}
      />
      <p className="sub-heading">
        <FormattedMessage id={"workflow.settings.invitationNote"} />
      </p>
      <p className="desc">
        <FormattedMessage id={"workflow.settings.writeAPersonalizedMessage"} />
      </p>
      <div className="textarea-wrapper">
        <TextArea
          onChange={(message) => handleOnChange(message, "message")}
          val={blockOptions.options.message}
          textAreaRef={textAreaRef}
          disabled={false}
          chars_limit={250}
          checkVarsValidity={setIsVarValid}
          type={"invitation"}
        />
      </div>
      <OverlayTrigger
        key={"plan-permission"}
        placement={"top"}
        overlay={(props) =>
          Tooltip({
            ...props,
            data: <FormattedMessage id={"workflow.settings.activateText"} />,
          })
        }
      >
        <label
          style={{
            margin: "10px 3px",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "9px",
            display: "block",
            cursor: "pointer",
          }}
        >
          <span className="sub-heading">
            <input
              type="checkbox"
              onChange={(e) => handleOnChange(e.target.checked, "isActive")}
              checked={getBlockActivation().active}
            />
            <span
              style={{
                display: "inline-block",
                marginLeft: 5,
                userSelect: "none",
              }}
            >
              <FormattedMessage id={"workflow.settings.active"} />
            </span>
          </span>
        </label>
      </OverlayTrigger>
      <div className="button-blocks">
        <a href="#" className="btn2" onClick={() => handleSettingsToggle()}>
          <FormattedMessage id={"cancel"} />
        </a>
        {!checkPlanPermissions("Edit") || !checkMemberPermissions("Edit") ? (
          <Permissions.CallToAction
            isButton={true}
            isPlan={!checkPlanPermissions("Edit")}
            toolTipStyle={{ width: 200, left: "25%" }}
          >
            <FormattedMessage id={"workflow.settings.saveThisStep"} />
          </Permissions.CallToAction>
        ) : (
          <a
            href="#"
            className="btn1"
            style={isVarValid ? {} : { background: "#ccc" }}
            onClick={() => isVarValid && handleStepSave(getBlockActivation())}
          >
            <FormattedMessage id={"workflow.settings.saveThisStep"} />
          </a>
        )}
      </div>
      <ToastContainer position="bottom-right" style={{ top: 100 }} />
    </div>
  );
}
function MessageConfig({
  handleSettingsToggle,
  handleStepSave,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);
  const [error, setError] = useState(null);
  const [isVarValid, setIsVarValid] = useState(true);
  const textAreaRef = useRef();

  const handleOnChange = (value, type) => {
    if (
      type == "isActive" &&
      textAreaRef.current &&
      !textAreaRef.current.value
    ) {
      textAreaRef.current.style.borderColor = "red";
    } else {
      if (textAreaRef.current)
        textAreaRef.current.style.borderColor = "inherit";
    }
    let template = state.selectedTemplate;
    const dfsResults = dfs(blockOptions.id, state.selectedTemplate.blocks);
    const reversDfsResults = reversDfs(
      blockOptions.id,
      state.selectedTemplate.blocks
    );

    template.blocks = state.selectedTemplate.blocks.map((block) => {
      if (type == "isActive") {
        const textareavalue = textAreaRef.current.value;
        if (!textareavalue && !block.active) {
          return block;
        }
        if (
          dfsResults.some((id) => id === block.id) ||
          (reversDfsResults.some((id) => id === block.id) && !block.active)
        ) {
          block.active = value;
          return block;
        }
      }
      if (block.id === blockOptions.id) {
        if (!value) {
          block.active = false;
        }
        let options = block.options;
        options.message = value;
        block.options = options;
      }
      return block;
    });
    dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
  };
  const getBlockActivation = () => {
    let block = state.selectedTemplate.blocks.find(
      (block) => block.id == blockOptions.id
    );
    return block;
  };

  return (
    <div className={"step1 " + (blockOptions ? "active" : "")}>
      <div className="setting-heading">
        <a
          href="#"
          className="close-btn"
          onClick={() => handleSettingsToggle()}
        >
          &times;
        </a>
        <label>
          <FormattedMessage id={"workflow.settings.step"} /> 1
        </label>
        <h4>
          <FormattedMessage id={"workflow.linkedinMessage"} />
        </h4>
        <p>
          <FormattedMessage id={"workflow.settings.sendAnAutomaticMessage"} />
        </p>
      </div>
      <p className="sub-heading">
        <FormattedMessage id={"workflow.settings.messageText"} />
      </p>
      <p className="desc">
        <FormattedMessage id={"workflow.settings.writeAPersonalized"} />
      </p>
      <div className="textarea-wrapper">
        <TextArea
          onChange={(message) => handleOnChange(message, "message")}
          val={blockOptions.options.message}
          textAreaRef={textAreaRef}
          disabled={false}
          chars_limit={250}
          checkVarsValidity={setIsVarValid}
        />
      </div>
      {error && (
        <div
          className="btn-grp text-center  error  kaspr-form-text-error"
          style={{ top: 0, width: "90%" }}
        >
          {error + " "}
        </div>
      )}
      <OverlayTrigger
        key={"plan-permission"}
        placement={"top"}
        overlay={(props) =>
          Tooltip({
            ...props,
            data: <FormattedMessage id={"workflow.settings.activateText"} />,
          })
        }
      >
        <label
          style={{
            margin: "10px 3px",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "9px",
            display: "block",
            cursor: "pointer",
          }}
        >
          <span className="sub-heading">
            <input
              type="checkbox"
              onChange={(e) => handleOnChange(e.target.checked, "isActive")}
              checked={getBlockActivation().active}
            />
            <span
              style={{
                display: "inline-block",
                marginLeft: 5,
                userSelect: "none",
              }}
            >
              <FormattedMessage id={"workflow.settings.active"} />
            </span>
          </span>
        </label>
      </OverlayTrigger>

      <div className="button-blocks">
        <a href="#" className="btn2" onClick={handleSettingsToggle}>
          <FormattedMessage id={"cancel"} />
        </a>
        {!checkPlanPermissions("Edit") || !checkMemberPermissions("Edit") ? (
          <Permissions.CallToAction
            isButton={true}
            isPlan={!checkPlanPermissions("Edit")}
            toolTipStyle={{ width: 200, left: "25%" }}
          >
            <FormattedMessage id={"workflow.settings.saveThisStep"} />
          </Permissions.CallToAction>
        ) : (
          <a
            href="#"
            className="btn1"
            style={isVarValid ? {} : { background: "#ccc" }}
            onClick={() => isVarValid && handleStepSave(getBlockActivation())}
          >
            <FormattedMessage id={"workflow.settings.saveThisStep"} />
          </a>
        )}
      </div>
    </div>
  );
}
function TimerConfig({
  handleSettingsToggle,
  handleStepSave,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);
  const dfsResults = dfs(blockOptions.id, state.selectedTemplate.blocks);
  const intl = useIntl();
  const handleOnChange = (value, type) => {
    let template = state.selectedTemplate;
    template.blocks = state.selectedTemplate.blocks.map((block) => {
      if (type == "isActive") {
        if (dfsResults.some((id) => id === block.id)) {
          block.active = value;
          return block;
        }
      }
      if (block.id === blockOptions.id) {
        block.options.checkDuration[type] = value;
      }
      return block;
    });
    dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
  };
  const getBlockActivation = () => {
    let block = state.selectedTemplate.blocks.find(
      (block) => block.id == blockOptions.id
    );
    return block;
  };

  return (
    <div className={"step1 " + (blockOptions ? "active" : "")}>
      <div className="timer-inner-flow">
        <div className="setting-heading">
          <a
            href="#"
            className="close-btn"
            onClick={() => handleSettingsToggle()}
          >
            ×
          </a>
          <h4>
            {" "}
            <FormattedMessage id={"workflow.settings.waitingTime"} />{" "}
          </h4>
          <p>
            {blockOptions.action === "linkedin-has-responded-bulk" ? (
              <FormattedMessage
                id={"workflow.settings.enterTheWaitingTimeMessage"}
              />
            ) : (
              <FormattedMessage id={"workflow.settings.enterTheWaitingTime"} />
            )}
          </p>
        </div>

        <div className="timer-fields-ui">
          <TimerField
            onChange={(delay) => handleOnChange(delay, "days")}
            value={blockOptions.options.checkDuration.days}
            label={intl.formatMessage({ id: "time.days" })}
          />
          <TimerField
            onChange={(delay) => handleOnChange(delay, "hours")}
            value={blockOptions.options.checkDuration.hours}
            label={intl.formatMessage({ id: "time.hours" })}
          />
          <TimerField
            onChange={(delay) => handleOnChange(delay, "minutes")}
            value={blockOptions.options.checkDuration.minutes}
            label={"minutes"}
          />
        </div>
      </div>

      <div className="button-blocks">
        <a href="#" className="btn2 close-btn" onClick={handleSettingsToggle}>
          <FormattedMessage id={"cancel"} />
        </a>
        {!checkPlanPermissions("Edit") || !checkMemberPermissions("Edit") ? (
          <Permissions.CallToAction
            isButton={true}
            isPlan={!checkPlanPermissions("Edit")}
            toolTipStyle={{ width: 200, left: "25%" }}
          >
            <FormattedMessage id={"workflow.settings.continue"} />
          </Permissions.CallToAction>
        ) : (
          <a
            href="#"
            className="btn1"
            onClick={() => handleStepSave(getBlockActivation())}
          >
            <FormattedMessage id={"workflow.settings.continue"} />
          </a>
        )}
      </div>
    </div>
  );
}

function EnrichConfig({
  handleSettingsToggle,
  handleStepSave,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);

  const handleOnChange = (checked, type) => {
    let template = state.selectedTemplate;
    template.blocks = state.selectedTemplate.blocks.map((block) => {
      if (block.id === blockOptions.id) {
        //dataToGet: {workEmails: true, phones: true, directEmails: true}
        if (["workEmails", "phones", "directEmails"].indexOf(type) > -1) {
          block.options.dataToGet = { ...block.options.dataToGet };
          block.options.dataToGet[type] = checked;
        } else {
          block.options[type] = checked;
        }
      }
      return block;
    });
    dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
  };

  /* const handleGoToWorkflow = () => {
    console.log(blockOptions.workflow);
    window.open(DASHBOARD_URL + "/workflow/" + blockOptions.workflow);
  };*/
  return (
    <div>
      <div>
        <div>
          <div className="setting-heading">
            <a
              href="#"
              className="close-btn"
              onClick={() => handleSettingsToggle()}
            >
              &times;
            </a>
            <h4>
              <FormattedMessage id={"workflow.enrichment"} />
            </h4>
          </div>
          <div id="enrichment" className="enrichment-flow">
            <p className="sub-title">
              {" "}
              <FormattedMessage id={"workflow.settings.enrichmentOptions"} />
              <span>
                <InfoToolTip
                  style={{ width: 16, marginLeft: 5, marginTop: -2 }}
                  text={
                    <FormattedMessage
                      id={"workflow.settings.enrichmentOptionsToolTip"}
                    />
                  }
                />
              </span>
            </p>
            <ul>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={blockOptions.options.isEmailProRequired}
                      onChange={(e) =>
                        handleOnChange(e.target.checked, "isEmailProRequired")
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">
                      <FormattedMessage
                        id={"workflow.settings.emailProRequired"}
                      />
                    </span>
                  </label>
                </div>
              </li>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={blockOptions.options.isPhoneRequired}
                      onChange={(e) =>
                        handleOnChange(e.target.checked, "isPhoneRequired")
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">
                      <FormattedMessage
                        id={"workflow.settings.mobileRequired"}
                      />
                    </span>
                  </label>
                </div>
              </li>
              <li></li>
            </ul>
          </div>
          <div
            id="enrichment"
            className="enrichment-flow"
            style={{ marginTop: 40 }}
          >
            <p className="sub-title">
              <FormattedMessage id={"workflow.settings.requestedData"} />{" "}
              <span>
                <InfoToolTip
                  style={{ width: 16, marginLeft: 1, marginTop: -2 }}
                  text={
                    <FormattedMessage
                      id={"workflow.settings.requestedDataToolTip"}
                    />
                  }
                />
              </span>
            </p>
            <ul>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        blockOptions.options.dataToGet &&
                        blockOptions.options.dataToGet.workEmails
                      }
                      onChange={(e) =>
                        handleOnChange(e.target.checked, "workEmails")
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">B2B Emails</span>
                  </label>
                </div>
              </li>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        blockOptions.options.dataToGet &&
                        blockOptions.options.dataToGet.phones
                      }
                      onChange={(e) =>
                        handleOnChange(e.target.checked, "phones")
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">Phones</span>
                  </label>
                </div>
              </li>
              <li></li>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        blockOptions.options.dataToGet &&
                        blockOptions.options.dataToGet.directEmails
                      }
                      onChange={(e) =>
                        handleOnChange(e.target.checked, "directEmails")
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">Direct emails</span>
                  </label>
                </div>
              </li>
              <li></li>
            </ul>
          </div>
          <div className="button-blocks">
            <a
              href="#"
              className="btn2 close-btn"
              onClick={() => handleSettingsToggle()}
            >
              <FormattedMessage id={"cancel"} />
            </a>
            {!checkPlanPermissions("Edit") ||
            !checkMemberPermissions("Edit") ? (
              <Permissions.CallToAction
                isButton={true}
                isPlan={!checkPlanPermissions("Edit")}
                toolTipStyle={{ width: 200, left: "25%" }}
              >
                <FormattedMessage id={"workflow.settings.saveThisStep"} />
              </Permissions.CallToAction>
            ) : (
              <a
                href="#"
                className="btn1"
                onClick={() => handleStepSave(blockOptions)}
              >
                <FormattedMessage id={"workflow.settings.saveThisStep"} />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function IntegrationConfig({
  handleSettingsToggle,
  active,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const [account, setAccount] = useState(null);
  const [showMappingModal, setMappingModal] = useState(false);
  const handleMappingModal = () => {
    setMappingModal(!showMappingModal);
  };
  useEffect(() => {
    const loadData = async () => {
      let { data, statusCode } = await getAccounts();
      if (data && data.accounts) setAccount(data.accounts[blockOptions.name]);
    };
    loadData();
  }, []);

  const handleStepSave = async () => {
    if (blockOptions._id) {
      await updateBlock(blockOptions);
    }
    handleSettingsToggle();
  };
  return (
    <div>
      <div>
        <div className="setting-heading">
          <a
            href="#"
            className="close-btn"
            onClick={() => handleSettingsToggle()}
          >
            &times;
          </a>
          <label>
            <FormattedMessage id={"workflow.settings.step"} />
          </label>
          <h4>
            {blockOptions.name === "zohocrm" ? "Zoho" : blockOptions.name}
          </h4>
        </div>
        <p className="msg">
          <FormattedMessage id={"workflow.settings.yourConnectedWith"} />{" "}
          <strong>{account && account[blockOptions.name + "Email"]}</strong>
        </p>
        <div className="spacer-block"></div>
        <div className="configure-block">
          <p className="sub-heading">
            <FormattedMessage id={"workflow.settings.settingTheExportTo"} />{" "}
            {blockOptions.name === "zohocrm" ? "Zoho" : blockOptions.name}
          </p>
          <p className="desc">
            <FormattedMessage id={"workflow.settings.setupYour_"} />{" "}
            {blockOptions.name === "zohocrm" ? "Zoho" : blockOptions.name}{" "}
            <FormattedMessage id={"workflow.settings.propertiesBelow"} />
          </p>
          <a
            href="#"
            className="btn1 configure-btn"
            data-toggle="modal"
            data-target="#configrations-modal"
            onClick={handleMappingModal}
          >
            <FormattedMessage id={"workflow.settings.configure"} />
          </a>
        </div>
        <div className="button-blocks">
          <a
            href="#"
            className="btn2 close-btn"
            onClick={() => handleSettingsToggle()}
          >
            <FormattedMessage id={"cancel"} />
          </a>
          <a href="#" className="btn1" onClick={() => handleSettingsToggle()}>
            <FormattedMessage id={"workflow.settings.saveThisStep"} />
          </a>
        </div>
      </div>

      {blockOptions.name == "zapier" && account ? (
        <ConnectionModal
          integration={blockOptions.name}
          category={"Integration"}
          imagesrc={"/assets/images/zapier.png"}
          show={showMappingModal}
          onHide={handleMappingModal}
          account={account.zapierEmail}
          checkMemberPermissions={checkMemberPermissions}
        />
      ) : (
        <MappingModal
          integration={blockOptions.name}
          category={""}
          imagesrc={"/assets/images/" + blockOptions.name + ".png"}
          show={showMappingModal}
          onHide={handleMappingModal}
          account={account}
          setIsLoading={() => null}
        />
      )}
    </div>
  );
}

function AttachedBock({
  handleSettingsToggle,
  active,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);
  const [blockToDelete, setBlockToDelete] = useState(false);
  const handleGoToWorkflow = () => {
    window.open(DASHBOARD_URL + "/workflow/" + blockOptions.workflow);
  };
  const handleDeleteWorkflow = async () => {
    let template = state.selectedTemplate;
    template.blocks = state.selectedTemplate.blocks.map((block) => {
      if (block.options && block.options.workflowId === blockOptions.workflow) {
        block.options.workflowId = null;
        if (block._id) {
          updateBlock(block).then(({ data, statusCode }) => {
            if (statusCode === 200) {
              handleSettingsToggle();
            }
          });
        }
      }
      return block;
    });
    dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
    handleSettingsToggle();
  };
  return (
    <div>
      <div>
        <div>
          <div className="setting-heading">
            <a href="#" className="close-btn" onClick={handleSettingsToggle}>
              &times;
            </a>
            <h4>
              <FormattedMessage id={"workflow.settings.attachment"} />
            </h4>
            <p>
              {blockOptions.action == "linkedin-enrich" ? (
                blockOptions.id == "10" ? (
                  <FormattedMessage id={"workflow.settings.thisActionEnrich"} />
                ) : (
                  <FormattedMessage id={"workflow.settings.thisActionEnrich"} />
                )
              ) : (
                <FormattedMessage
                  id={
                    "workflow.settings.thisActionAllowsYouToSetIntegProperties"
                  }
                />
              )}
            </p>
          </div>
          <div id="enrichment" className="enrichment-flow">
            <p className="sub-title">
              <FormattedMessage id={"workflow.settings.attachmentOptions"} />
            </p>
            <div style={{ marginTop: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  className={"btn1"}
                  style={{ width: 100 }}
                  onClick={handleGoToWorkflow}
                >
                  <FormattedMessage id={"workflow.settings.configure"} />
                </button>
                {!checkPlanPermissions("Edit") ||
                !checkMemberPermissions("Edit") ? (
                  <Permissions.CallToAction
                    isButton={true}
                    isPlan={!checkPlanPermissions("Edit")}
                    toolTipStyle={{ width: 200, left: "25%" }}
                    buttonStyle={{ width: 100, background: "darkred" }}
                  >
                    <FormattedMessage id={"delete"} />
                  </Permissions.CallToAction>
                ) : (
                  <button
                    className={"btn1"}
                    style={{ width: 100, background: "darkred" }}
                    onClick={setBlockToDelete}
                  >
                    <FormattedMessage id={"delete"} />
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="button-blocks">
            <a
              href="#"
              className="btn2 close-btn"
              onClick={handleSettingsToggle}
            >
              Cancel
            </a>
            <a href="#" className="btn1" onClick={handleStepSave}>
              Save this step
            </a>
          </div>*/}
        </div>
      </div>
      {blockToDelete && (
        <ModalMessage
          title={<FormattedMessage id={"workflow.settings.removeAttachment"} />}
          textElement={
            <p>
              <strong>
                <FormattedMessage
                  id={
                    "workflow.settings.areYouSureYouWantToRemoveThisAttachment"
                  }
                />{" "}
              </strong>
              <br />
              <FormattedMessage id={"workflow.settings.pleaseClickToRemove"} />
            </p>
          }
          action={<FormattedMessage id={"workflow.settings.confirmRemove"} />}
          toggle={blockToDelete}
          setToggle={() => setBlockToDelete(false)}
          handleAction={handleDeleteWorkflow}
        />
      )}
    </div>
  );
}

function AttachBlock({
  handleSettingsToggle,
  profile,
  blockOptions,
  checkPlanPermissions,
  checkMemberPermissions,
}) {
  const { state, dispatch } = useContext(WorkflowContext);
  const [workflows, setWorkflows] = useState([]);
  const [workflowToAttach, selectWorkflowToAttach] = useState([]);
  const [workflowTab, setWorkflowTab] = useState("existing");
  const [selectedIntegrationList, selectIntegrationList] = useState(null);
  const workflowNameInputRef = useRef();
  const [selectedIntegration, setSelectedIntegration] = useState();
  const [enrichConfig, setEnrichConfig] = useState({
    isPhoneRequired: false,
    isEmailProRequired: false,
    workflowName: "",
    dataToGet: { workEmails: true, phones: true, directEmails: true },
  });

  useEffect(() => {
    if (state.selectedTemplate.type == "enrichment") {
      getWorkflows({
        filters: {
          all: true,
          type: ["integration"],
        },
      }).then(({ data, statusCode }) => {
        if (statusCode === 200) {
          const integrationWorkflows = data.workflows.filter(
            (wk) => wk.type === "integration"
          );
          if (integrationWorkflows.length == 0) setWorkflowTab("new");
          setWorkflows(integrationWorkflows);
        }
      });
    } else {
      getWorkflows({
        filters: {
          all: true,
          type: ["enrichment"],
        },
      }).then(({ data, statusCode }) => {
        if (statusCode === 200) {
          const enrichWorkflows = data.workflows.filter(
            (wk) => wk.type === "enrichment"
          );
          if (enrichWorkflows.length == 0) setWorkflowTab("new");
          setWorkflows(enrichWorkflows);
        }
      });
    }
  }, []);

  const handleAttachBlock = async () => {
    let workflowToAttachCopy = { ...workflowToAttach };
    if (blockOptions._id || !workflowToAttachCopy._id) {
      if (workflowTab === "new") {
        workflowToAttachCopy = await handleCreateWorkflow();
        if (!workflowToAttachCopy) return;
      }
      if (
        checkPermission({
          permissions: profile.permissions,
          name: "Workflow",
          action: "Edit",
        })
      ) {
        if (!workflowToAttachCopy._id) return;
        if (blockOptions.options) {
          blockOptions.options.workflowId = workflowToAttachCopy._id;
          blockOptions.options.name = workflowToAttachCopy.name;
        } else {
          blockOptions.options = {
            workflowId: workflowToAttachCopy._id,
            name: workflowToAttachCopy.name,
          };
        }
        const { data, statusCode } = await updateBlock(blockOptions);
        if (statusCode === 200) {
          handleSettingsToggle();
        }
      } else {
        toast.error(<FormattedMessage id={"permissions.noAccess"} />);
      }
      handleSettingsToggle();
    } else {
      let template = state.selectedTemplate;
      template.blocks = state.selectedTemplate.blocks.map((block) => {
        if (block.id === blockOptions.id) {
          block.options.workflowId = workflowToAttachCopy._id;
        }
        return block;
      });
      dispatch({ type: actions.SELECTED_TEMPLATE, payload: template });
      handleSettingsToggle();
    }
  };

  const handleCreateWorkflow = async () => {
    const { data } = await getTemplates();
    const myTemplate = data.templates.find(
      (template) =>
        template.type == "enrichment" || template.type === "integration"
    );
    if (selectedIntegration) {
      myTemplate.type = "integration";
      myTemplate.blocks = [
        {
          id: 1,
          name: selectedIntegration,
          action: "integration-" + selectedIntegration,
          type: "flow_action",
          options: { email: "" },
        },
      ];
    }
    if (myTemplate.type == "enrichment") {
      if (!enrichConfig.workflowName) {
        return (workflowNameInputRef.current.style.borderColor = "red");
      } else {
        workflowNameInputRef.current.style.borderColor = "inherit";
      }
      myTemplate.blocks = myTemplate.blocks.map((block) => {
        if (block.id == "1") {
          block.options.addLead = true;
          block.options.isEmailProRequired = enrichConfig.isEmailProRequired;
          block.options.isPhoneRequired = enrichConfig.isPhoneRequired;
          block.options.dataToGet = enrichConfig.dataToGet;
        }
        return block;
      });
    }
    if (
      checkPermission({
        permissions: profile.permissions,
        name: "Workflow",
        action: "Edit",
      })
    ) {
      myTemplate.name = enrichConfig.workflowName || selectedIntegration;
      const { data, statusCode } = await createWorkflow(myTemplate);
      if (statusCode === 200) {
        return data.workflow;
      }
    } else {
      toast.error(<FormattedMessage id={"permissions.noAccess"} />);
    }
  };

  const handleOnEnrichConfig = async (value, type) => {
    let newConfig = { ...enrichConfig };
    newConfig[type] = value;
    setEnrichConfig(newConfig);
  };
  return (
    <div>
      <div className="setting-heading">
        <a href="#" className="close-btn" onClick={handleSettingsToggle}>
          &times;
        </a>
        <label>
          <FormattedMessage id={"workflow.settings.step"} /> 7
        </label>
        <h4>
          <FormattedMessage id={"workflow.settings.attachABlock"} />
        </h4>
        <p>
          <FormattedMessage
            id={
              workflowTab == "existing"
                ? "workflow.settings.thisActionHelpsYouToAttach"
                : "workflow.settings.thisActionHelpsYouToAttachNew"
            }
          />
        </p>
      </div>
      <div className="attach-block-wrapper">
        {workflows.length > 0 && (
          <div className="workflow-tab-list new_block_tab active">
            <ul className="nav nav-tabs">
              <li style={{ margin: 0 }}>
                <a
                  className={workflowTab == "existing" ? "active show" : ""}
                  onClick={() => setWorkflowTab("existing")}
                >
                  <FormattedMessage id={"workflow.existing"} />
                </a>
              </li>
              <li style={{ margin: 0 }}>
                <a
                  className={workflowTab == "new" ? "active show" : ""}
                  onClick={() => setWorkflowTab("new")}
                >
                  <FormattedMessage id={"workflow.new"} />
                </a>
              </li>
            </ul>
          </div>
        )}
        {workflowTab == "existing" ? (
          <div className="workflow-tab-list existing-workflow-tab active">
            <p className="sub-title">
              {" "}
              <FormattedMessage id={"workflow.settings.chooseAnExisting"} />
            </p>
            <ul>
              {workflows.map((wk, i) => (
                <ExistingWorkflow
                  workflow={wk}
                  key={i}
                  selectWorkflowToAttach={selectWorkflowToAttach}
                />
              ))}
            </ul>
          </div>
        ) : state.selectedTemplate.type == "enrichment" ? (
          <AttachIntegration
            selectIntegrationList={selectIntegrationList}
            selectedIntegrationList={selectedIntegrationList}
            setSelectedIntegration={setSelectedIntegration}
            selectedIntegration={selectedIntegration}
          />
        ) : (
          <div className={"custom-enrichment-attach"}>
            {" "}
            <div>
              <input
                type="text"
                placeholder={"Workflow name"}
                autoFocus
                onChange={(e) =>
                  handleOnEnrichConfig(e.target.value, "workflowName")
                }
                value={enrichConfig.workflowName}
                ref={workflowNameInputRef}
              />
            </div>
            <ul>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={blockOptions.options.isEmailProRequired}
                      onChange={(e) =>
                        handleOnEnrichConfig(
                          e.target.checked,
                          "isEmailProRequired"
                        )
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">
                      <FormattedMessage
                        id={"workflow.settings.emailProRequired"}
                      />
                    </span>
                  </label>
                </div>
              </li>
              <li>
                <div className="checkbox-wrap">
                  <label>
                    <input
                      type="checkbox"
                      checked={blockOptions.options.isPhoneRequired}
                      onChange={(e) =>
                        handleOnEnrichConfig(
                          e.target.checked,
                          "isPhoneRequired"
                        )
                      }
                    />
                    <span className="checkbox-icon"></span>
                    <span className="checkbox-text">
                      <FormattedMessage
                        id={"workflow.settings.mobileRequired"}
                      />
                    </span>
                  </label>
                </div>
              </li>
              <li></li>
            </ul>
          </div>
        )}
      </div>
      <div className="button-blocks">
        <a
          href="#"
          className="btn2 close-btn"
          onClick={() => handleSettingsToggle()}
        >
          <FormattedMessage id={"cancel"} />
        </a>
        {!checkPlanPermissions("Edit") || !checkMemberPermissions("Edit") ? (
          <Permissions.CallToAction
            isButton={true}
            isPlan={!checkPlanPermissions("Edit")}
            toolTipStyle={{ width: 200, left: "25%" }}
            buttonStyle={{ background: "red" }}
          >
            <FormattedMessage id={"workflow.settings.continue"} />
          </Permissions.CallToAction>
        ) : (
          <a href="#" className="btn1" onClick={handleAttachBlock}>
            <FormattedMessage id={"workflow.settings.continue"} />
          </a>
        )}
      </div>
    </div>
  );
}
function ExistingWorkflow({ workflow, selectWorkflowToAttach }) {
  return (
    <li onClick={() => selectWorkflowToAttach(workflow)}>
      <label className="radio-btn">
        <input type="radio" id="existingworkflow" name={"existingworkflow"} />
        <span className="radio-icon"></span>
        <div className="radio-text">
          <span className="tag red-text">
            <FormattedMessage id={"workflow." + workflow.type} />
          </span>
          {workflow.name}
        </div>
      </label>
    </li>
  );
}
